module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.appIsUpdating !== false) ? _c('div', {
    staticClass: "app-update-modal"
  }, [(_vm.appIsUpdating === 'error') ? _c('p', {
    staticClass: "error"
  }, [_c('translate', {
    attrs: {
      "translate-context": "update modal"
    }
  }, [_vm._v("Error! Please try again later")])], 1) : _c('p', [_vm._v(_vm._s(_vm.appIsUpdating))])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d9519e3c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/update-progress.vue
// module id = 353
// module chunks = 1